import { Box } from "@mui/system";
import React from "react";
import FooterSection from "./footer-section/footerSection";
import FormSection from "./form-section/formSection";

const Footer = ({ footerNode }) => {
  return (
    <Box>
      {footerNode.formSection ? <FormSection footerNode={footerNode} /> : null}
      {footerNode.footerSection ? (
        <FooterSection footerNode={footerNode} />
      ) : null}
    </Box>
  );
};

export default Footer;
